var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 386,
    viewBox: "0 0 174 386",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 385.5C116.5 339 -46.6945 239.015 25.5 222.5C102 205 155.5 277.5 169 257.5C189.793 226.696 51.6012 184.335 74.5 153C83.3472 140.893 134.075 147.059 159 129C187.603 108.275 140.559 63.8979 116.5 45.5001C74 13.0004 29.3333 -2.33335 0.5 3.99998",
    stroke: "#FBE5B6",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/Stroke.28d57c90dd82a2af69978ef0fff848d2.svg";
export { ForwardRef as ReactComponent };